import { render, staticRenderFns } from "./PossessedAttestationContent.vue?vue&type=template&id=72e571de&scoped=true&"
import script from "./PossessedAttestationContent.vue?vue&type=script&lang=js&"
export * from "./PossessedAttestationContent.vue?vue&type=script&lang=js&"
import style0 from "./PossessedAttestationContent.vue?vue&type=style&index=0&id=72e571de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e571de",
  null
  
)

export default component.exports